import React, { Fragment, useState } from "react";
import { Button, Menu } from "@theorgchartdev/storybook";
import {
  CheckBoxCellControlEnabled,
  DeleteColumn,
  DeleteLayoutField,
  DeleteRow,
  DisableAnyInsert,
  DisableFieldDelete
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { appstr } from "@coreapp/utils/appstr";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import LayoutTypeModal from "@/appComponents/Blocks/Modals/LayoutTypeModal/LayoutTypeModal";
import { GetWSMgr } from "@/Utils/StateLib";
import { enumHierarchyTypes } from "@coreapp/constants";

const BLEEditOptions = [
  {
    value: "delete",
    label: appstr("Delete"),
    icon: "trash",
    options: [
      {
        value: "deleterows",
        clickHandler: DeleteRow
      },
      {
        value: "deletecols",
        clickHandler: DeleteColumn
      },
      {
        value: "deletefield",
        clickHandler: DeleteLayoutField,
        disabled: DisableFieldDelete
      }
    ],
    disabled: DisableAnyInsert
  }
];

const BuildEditOptions = (canAccessGrouping, openLayoutTypeModal) => {
  let options = [];
  if (canAccessGrouping) {
    options.push({
      value: "layouttype",
      label: appstr("Layout type"),
      dataTestId: "mtb-layout-editor-edit-menu-layouttype",
      clickHandler: openLayoutTypeModal
    });
  }
  for (let editOpt of BLEEditOptions) {
    let opt = {};
    opt.value = editOpt.value;
    opt.label = appstr(editOpt.label);
    opt.icon = editOpt.icon;
    opt.divider = editOpt.divider;
    opt.dataTestId = `mtb-layout-editor-edit-menu-${editOpt.value}`;
    if (editOpt.options) {
      opt.options = editOpt.options;
      opt.options.forEach(item => {
        item.disabled =
          typeof item.disabled === "function"
            ? item.disabled()
            : !CheckBoxCellControlEnabled(item.value);
        item.label = appstr(item.value);
        item.dataTestId = `mtb-layout-editor-edit-menu-${editOpt.value}-${item.value}`;
      });
      opt.listProps = {
        "data-testid": `mtb-layout-editor-edit-menu-${editOpt.value}-popover`
      };
    }
    if (editOpt.clickHandler) opt.clickHandler = editOpt.clickHandler;
    opt.disabled = editOpt.disabled();
    options.push(opt);
  }
  return options;
};

export const BoxLayoutEditorEditMenu = () => {
  const { canAccessGrouping } = usePermissionCheck();
  const [showModal, setShowModal] = useState(false);
  const wsMgr = GetWSMgr();
  const isPositionLayout =
    wsMgr?.GetBLELayout()?.GetHierarchyType() === enumHierarchyTypes.positions;
  const isPositionChart = wsMgr?.GetDoc()?.IsPositionDocument() ?? false;

  return (
    <Fragment>
      <Menu
        dataTestId="mtb-layout-editor-edit-menu"
        trigger={
          <Button modifier="ghost" size="medium" type="button">
            {appstr("Edit")}
          </Button>
        }
        options={BuildEditOptions(canAccessGrouping && !isPositionLayout && !isPositionChart, () =>
          setShowModal(true)
        )}
        listWidth={"medium"}
      />
      {showModal && <LayoutTypeModal show={showModal} onClose={() => setShowModal(false)} />}
    </Fragment>
  );
};
